export const MESSAGE_DELAY = 1000
export const NO_CONVO_CHAT_AGGREGATE_HEIGHT = 155
export const DEFAULT_ACTIVE_CHAT_HEIGHT = 600
export const FOOTER_AGG_HEIGHT = 18
export const FOOTER_GDPR_OFFSET = 7
export const FOOTER_GDPR_OFFSET_NO_BRANDING = FOOTER_GDPR_OFFSET + 7
export const DECLINED_GDPR_OFFSET = 40 // height of the composer
export const SLIDER_MESSAGE_BUFFER_HEIGHT = 80 // top & bottom from padding and position of iframe
export const EMAIL_SENDER_ICON_BUFFER_HEIGHT = 35
export const CHAT_EMPTY_SIZE = '205px'
